import React, { useState } from 'react';
import QRCode from 'react-qr-code';

import Span from 'components/elements/span';
import { RootState } from 'redux/rootReducer';
import { useSelector } from 'react-redux';
import useMedia from 'hooks/useMedia';
import getMobileOS from 'helpers/getMobileOS';
import Modal from 'components/utility/Modal/Modal';

import { ReactComponent as IphoneIcon } from 'icons/iphone-opus-notifier.svg';
import IOSSection from './components/IOSSection';
import AndroidSection from './components/AndroidSection';
import AndroidInterestText from './components/AndroidInterestText';
import InstallationInstructions from './components/InstallationInstructions';

import TopBar from 'components/Header/TopBar/TopBar';
import Header from 'components/Header/Header';

import {
  Section,
  TextBlock,
  Wrapper,
  IconWrapper,
  MainText,
  SubText,
  StepsBlock,
  StepOne,
  StepTwo,
  QRCodeWrapper,
  InstallationInstructionsButton,
} from './styles';

const HeaderPanel: React.FC = () => {
  const isMobileScreen = useMedia('(max-width: 45em)');
  const [isOpenModal, setIsOpenModal] = useState(false);

  const ON_linkUrl: any = useSelector(
    (state: RootState): any => state.consulEnvData?.data?.ON_linkUrl
  );

  const openModal = (): void => setIsOpenModal(true);
  const closeModal = (): void => setIsOpenModal(false);

  const mobileOS = getMobileOS();

  return (
    <>
      {isOpenModal && (
        <Modal
          margin={isMobileScreen ? '0 auto' : '5em auto'}
          alignSelf={'start'}
          hide={closeModal}
          isFullScreen={!isMobileScreen}
        >
          <InstallationInstructions
            isMobileScreen={isMobileScreen}
            close={closeModal}
          />
        </Modal>
      )}
      <Wrapper isMobileScreen={isMobileScreen}>
        <Header entityTitle="NotifierApp" isMobileScreen={isMobileScreen}>
          <TopBar entityTitle="Home" isStatic />
        </Header>
        <Section>
          {!isMobileScreen && (
            <>
              <TextBlock>
                <MainText>Get the New OPUS Notifier App for iPhone</MainText>
                <StepsBlock>
                  <StepOne>
                    <SubText>1. Scan the QR Code to download the app</SubText>
                    <QRCodeWrapper>
                      <QRCode value={ON_linkUrl || ''} size={120} />
                    </QRCodeWrapper>
                  </StepOne>
                  <StepTwo>
                    <SubText>
                      2. Follow instructions to start receiving push
                      notifications
                    </SubText>
                    <InstallationInstructionsButton
                      onClick={openModal}
                      type="button"
                    >
                      <Span fontWeight={700}>Installation Instructions</Span>
                    </InstallationInstructionsButton>
                  </StepTwo>
                </StepsBlock>
                <AndroidInterestText />
              </TextBlock>
              <IconWrapper>
                <IphoneIcon />
              </IconWrapper>
            </>
          )}
          {isMobileScreen &&
            (mobileOS === 'iOS' ? (
              <IOSSection ON_linkUrl={ON_linkUrl} openModal={openModal} />
            ) : (
              <AndroidSection />
            ))}
        </Section>
      </Wrapper>
    </>
  );
};

export default HeaderPanel;
